import React from "react";
import styled from "styled-components";
import Wp3Dropdown from "../../../components/utilities/Dropdown";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GraphSubscriptionType } from "../../../types/GraphSubscriptionType";
import { useSubscriptionControls } from "../hooks/useSubscriptionControls";

export type GraphSubscriptionTableRowActionColumnProps = {
    data: GraphSubscriptionType,
    width?: number
};

const ActionColumnParent = styled.td`
    width: ${({ width }) => width}%;
    cursor: pointer;
    vertical-align: middle;
    text-align: ${(props: any) => props.textAlign ?? "left"};
`;

const ActionColumnParentToggle = React.forwardRef<HTMLDivElement, any>(({ ...rest }, ref) => (
    <div ref={ref} {...rest}>
        <FontAwesomeIcon icon={['fas', 'ellipsis']} />
    </div>
));

const GraphSubscriptionTableRowActionColumn = ({ data, width }: Readonly<GraphSubscriptionTableRowActionColumnProps>) => {
    const menuId = React.useId();
    const { deleteSubscription, refreshSubscription } = useSubscriptionControls(data);
    return (
        <ActionColumnParent width={width}>
            <Dropdown className="caret-off">
                <Dropdown.Toggle id={menuId} as={ActionColumnParentToggle} />
                <Dropdown.Menu style={{ maxWidth: '14rem' }}>
                    <Wp3Dropdown.MenuItem icon={['fas', 'retweet']} text="Refresh Subscription" onClick={refreshSubscription} />
                    <Wp3Dropdown.MenuHeader variant={'danger'}>
                        Danger Zone
                    </Wp3Dropdown.MenuHeader>
                    <Wp3Dropdown.MenuItem variant={'danger'} icon={['fas', 'trash-can']} text="Delete Subscription" onClick={deleteSubscription} />
                </Dropdown.Menu>
            </Dropdown>
        </ActionColumnParent>
    )
};

export default GraphSubscriptionTableRowActionColumn;